import { render, staticRenderFns } from "./CreateFormShare.vue?vue&type=template&id=35bf599a&scoped=true"
import script from "./CreateFormShare.vue?vue&type=script&lang=js"
export * from "./CreateFormShare.vue?vue&type=script&lang=js"
import style0 from "./CreateFormShare.vue?vue&type=style&index=0&id=35bf599a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf599a",
  null
  
)

export default component.exports